export default __webpack_public_path__ + "static/media/result.d1d91ea3.mp4";